'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var PropertyLoader = require('./util/property-loader');
var PackageJsonLoader = require('./npm/package-json-loader');

/**
 * dpndon fetch information of npm modules that the project depend on.
 */
module.exports = function (_ref) {
  var pkgName = _ref.pkgName,
      dependencyTypes = _ref.dependencyTypes,
      props = _ref.props;

  var loader = createPropLoader({ pkgName: pkgName });
  var dependenciesArray = dependencyTypes.map(function (type) {
    return loader.loadProp(type).then(function (dependencies) {
      return Object.entries(dependencies || {}).map(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            name = _ref3[0],
            version = _ref3[1];

        var loader = createPropLoader({
          pkgName: name,
          version: version
        });
        return loader.loadProps(props);
      });
    }).then(function (props) {
      return Promise.all(props);
    });
  });
  return Promise.all(dependenciesArray).then(function (dependenciesArray) {
    return dependenciesArray.reduce(function (result, dependencies, index) {
      var type = dependencyTypes[index];
      result[type] = dependencies;
      return result;
    }, {});
  });
};

/**
 * create property loader for package.json
 * @param {String} pkgName 
 * @param {String} version
 * @return {PropertyLoader} propertyLoader
 */
function createPropLoader(_ref4) {
  var pkgName = _ref4.pkgName,
      version = _ref4.version;

  return new PropertyLoader(new PackageJsonLoader(pkgName, version));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/dpndon/dist/dpndon.js
// module id = 777
// module chunks = 0